import React, { Component } from 'react'
import { connect } from 'react-redux'
import { translation } from '../../../../../utils/helpers'
import { ProductionStatus, MainMenuIcons, CapacityManagementIcons, TimeLineIcons } from '../../../../elements/icons'
import Icon from '../../../../elements/icon'
import CarRentalPlate from './../../../../components/CarRentalPlate'
import TimeLineSegment from './../../../../elements/timeLineSegment'

import './timelinestep.scss'
import { isArray } from 'lodash'
import moment from 'moment'
class TimeLineStep extends Component {

  getProcessLine (step) {
    let icon, text, bottom
    switch (step.StepType) {
      case 1:
        icon = ProductionStatus.Step_New
        text = 164
        break

      case 2:
        icon = ProductionStatus.Step_BodyShopDisassemply
        text = 617
        if (!step.Completed && !step.Active) bottom = this.renderDateLine(step.Date)
        break

      case 3:
        icon = ProductionStatus.Step_BodyShopRepair
        text = 618
        if (!step.Completed && !step.Active) bottom = this.renderDateLine(step.Date)
        if (this.props.orderTimeLine.NeedSparePartOrdering) bottom = this.renderIssueLine(translation(637))   // Spare parts
        break

      case 4:
      case 8:
        icon = ProductionStatus.Step_Painting
        text = 161
        if (!step.Completed && !step.Active) bottom = this.renderDateLine(step.Date)
        if (this.props.orderTimeLine.NeedPaintBooking) bottom = this.renderIssueLine(translation(412))  // Not booked
        break

      case 10:
        icon = ProductionStatus.Step_BodyShopAssembly
        text = 619
        if (!step.Completed && !step.Active) bottom = this.renderDateLine(step.Date)
        break

      case 11:
        icon = ProductionStatus.Step_BodyShopFinishing
        text = 162
        if (!step.Completed && !step.Active) bottom = this.renderDateLine(step.Date)
        break

      case 12:
        icon = ProductionStatus.Step_Handover
        text = 163
        if (!step.Completed && !step.Active) bottom = this.renderDateLine(step.Date)
        break

      case 13:
        icon = ProductionStatus.Step_Completed
        text = 16669
        if (!step.Completed && !step.Active) bottom = this.renderDateLine(step.Date)
        break

      case 14:
      case 15:
        icon = MainMenuIcons.CarRental_Black
        text = 629
        bottom = this.renderDateLine(step.Date)
        break

      default:
        break
    }

    const renderCarRental = (step) => {
      if (isArray(step.CarRentals) && step.CarRentals.length > 0) {
        // Show only 2 rentals
        let carRentals = step.CarRentals.slice(0, 2)
        let hiddenEntries = step.CarRentals.length - 2
        return (
          <span className='carrental-plates'>
            {carRentals.map(x => <CarRentalPlate regNr={x.RegNr} countryCode={this.props.CountryCode} nr={x.CarNumber} />)}
            {hiddenEntries > 0 ? (<span className='hidden-cars'>{'+ ' + hiddenEntries}</span>) : null}
          </span>
        )
      }
      return null
    }
    let topLineClasses = 'top'
    if (isArray(step.CarRentals) && step.CarRentals.length > 0) topLineClasses += ' full rental'
    return [
      <div className={topLineClasses} key='top'>
        <div className='processIcon'>
          <Icon icon={icon} size='s' injectSvg />
        </div>
        <div className='processName'>
          <span className='processName__text'>{translation(text)}</span>
          {renderCarRental(step)}
        </div>
      </div>,
      <div className='bottom' key='bottom'>
        {bottom}
      </div>
    ]
  }

  renderDateLine (dateTime) {
    if (dateTime === null) return null

    const formatDateTime = (dateTime) => {
      let locale = 'en'
      let languageName = window.localStorage.getItem('user_language')
      switch (languageName) {
        case 'Danish':
          locale = 'da'
          break
        case 'English':
          locale = 'en'
          break
        case 'Swedish':
          locale = 'se'
          break
        case 'Norwegian':
          locale = 'nb_NO'
          break
      }

      let mom = moment(dateTime).locale(locale)
      let dayOfWeek = mom.format('dddd')
      let day = mom.format('D')
      let month = mom.format('MMM')
      let hour = mom.format('k')   // "k" of all things...!
      let min = mom.format('mm')
      dayOfWeek = dayOfWeek.slice(0, 1).toUpperCase() + dayOfWeek.slice(1)
      month = month.slice(0, 1).toUpperCase() + month.slice(1)
      return `${dayOfWeek}, ${day} ${month} · ${hour}:${min}`
    }

    return (
      <span className='indented-datetime'>
        <span><Icon icon={CapacityManagementIcons.Indent} injectSvg size='t' /></span>
        <span>{formatDateTime(dateTime)}</span>
      </span>
    )
  }

  renderIssueLine (issueText) {
    return (
      <span className='indented-issue'>
        <span className='indent-icon'><Icon icon={CapacityManagementIcons.Indent} injectSvg size='t' /></span>
        <span className='issue-icon'><Icon icon={TimeLineIcons.Exclamation_Red} size='t' /></span>
        <span className='issue-text'>{issueText}</span>
      </span>
    )
  }

  render () {
    if (this.props.step === undefined || this.props.step === null) return null
    let step = this.props.step

    let stepClassname = 'timelineStep'
    if (step.Active) {
      stepClassname += ' active'
    } else if (step.Completed) {
      stepClassname += ' completed'
    }

    return (
      <div className={stepClassname} key={this.props.key}>
        <div className='lines'>
          <TimeLineSegment lines={step.Lines} active={step.Active} topHeight='14px' bottomHeight='1fr' />
        </div>
        <div className='process'>
          {this.getProcessLine(step)}
        </div>
        {step.TimeAssessment !== undefined && (
          <div className='assessment'>{step.TimeAssessment}</div>
        )}
        {step.TimeAssessment !== undefined && (
          <div className='available'>{step.TimeAvailable}</div>
        )}
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {})(TimeLineStep)




// WEBPACK FOOTER //
// ./src/app/shared/overlays/OrderCapacityOverview/TimelineSlidePanel/TimeLineStep/index.js